import * as moment from "moment/moment";
import {mapGetters} from "vuex";

export default {
    props:['list', 'itemId'],
    components:{
        Table: ()=> import('@/components/table/list/index.vue'),
    },
    data(){
        return{
            historyList: null,
            fields:[
                {
                    key:'id',
                    label:'id',
                },
                {
                    key:'title',
                    label:'name',
                },
                {
                    key:'login',
                    label:'login',
                },
                {
                    key:'operation',
                    label:'operation',
                },
                {
                    key:'updated_at',
                    label:'updated_at',
                },
                {
                    key:'userIp',
                    label:'ip',
                },
                {
                    key:'device',
                    label:'device',
                },
            ],
            items:[],
            changesLIst:null,
            changesType:{
                'customer_name': this.$t('popupChanges.customer_name'),
                'email':'Email',
                'phone': this.$t('popupChanges.phone'),
                'comment': this.$t('popupChanges.comment'),
                'address': this.$t('popupChanges.address'),
                'order_status_id': this.$t('popupChanges.order_status_id'),
                'shipment_method_id': this.$t('popupChanges.shipment_method_id'),
                'department_id': this.$t('popupChanges.department_id'),
                'ip':'ip',
                'updated_at': this.$t('popupChanges.updated_at'),
                "payment_method_id": this.$t('popupChanges.payment_method_id'),
                "shipment_date": this.$t('popupChanges.shipment_date'),
                "employee_id":"employee_id",
                "order_id":"order_id",
                "completed": this.$t('popupChanges.completed'),
                "created_at":"timestamp without time zone",
                "shipment_data":"json",
                "status_open": this.$t('popupChanges.status_open'),
                "user_id_open": this.$t('popupChanges.user_id_open'),
                "id":"id",
                "site": this.$t('popupChanges.site'),
                "user_login_open":"character varying",
                "country": this.$t('popupChanges.country'),
                "manager_comment": this.$t('popupChanges.manager_comment'),
                "cancel_reason": this.$t('popupChanges.cancel_reason'),
                "utm_source":"utm_source",
                "utm_medium":"utm_medium",
                "utm_term":"utm_term",
                "utm_content":"utm_content",
                "utm_campaign":"utm_campaign",
                "ttn":"ttn",
            }

        }
    },
    computed:{
        ...mapGetters({
            departments:'catalog/departments',
            shipmentMethods:'orders/shipmentMethods',
            orderStatusList:'orders/orderStatusList',
            paymentMethods:'orders/paymentMethods',
        })
    },
    created() {
        if(this.list.form.order_changes.length){
            this.changeHistoryList(this.list.form.order_changes);
        }
    },
    methods:{
        orderStatus(id){
            const itemType = this.orderStatusList.data.filter(item => item.id === id)[0]
            return itemType.title
        },
        shipmentMethod(id){
            const itemType = this.shipmentMethods.data.filter(item => item.id === id)[0]
            return itemType.title
        },
        department(id){
            const itemType = this.departments.data.filter(item => item.id === id)[0]
            return itemType.title
        },
        paymentMethod(id){
            const itemType = this.paymentMethods.data.filter(item => item.id === id)[0]
            return itemType.title
        },
        changeHistoryList(e){
            e.map(item=>{
                this.items.push(
                    {
                        id:item.id ? item.id : '',
                        title:item.member ? item.member : '',
                        login:item.login ? item.login : '',
                        operation:item.operation ? {operation:item.operation, id:item.id} : '',
                        updated_at:item.updated_at ? moment(item.updated_at).format('YYYY-MM-DD HH:mm') : '',
                        userIp:item.ip ? item.ip : '',
                        device:item.device ? item.device : '',
                    }
                )
            })
        },
        closePopup(){
            this.$emit('closePopup');
        },
        showWhatChanges(e){
            this.changesLIst = null;
            const choiseItem = this.list.form.order_changes.filter(item => item.id === e)[0]
            this.changesLIst = choiseItem.data
        }
    },
    destroyed() {
        this.historyList = null;
        this.changesLIst = null;
    }
}